<div class="page-container">
  <div class="page-heading">
    <h3 class="bold-text black-text"><img src="assets/icons/person_black_24dp.svg"><span class="ms-2">{{'sideNavigation.titleCallService' | translate}}</span></h3>
  </div>
  <div class="page-content">
    <div class="card">
      <div class="card-body">
        <div class="margin-left">
          <button class="btn btn-secondary border-zero padding-fix" (click)="toCallServicesPage()">{{'basic.back' | translate}}</button>
          <form ngNativeValidate (ngSubmit)="saveEdit(1)">
            <div class="row margin-top">

              <div class="col-5">
                <div class="large bold-text row">
                  <div>
                    <span id="callService-name">{{name}}</span>
                    @if (!editMode1) {
                      <button class="btn btn-secondary float-end me-3" (click)="toggleEdit(1)"><img src="assets/icons/edit_gray_24dp.svg" class="image-edit"><span class="ms-1">{{'basic.edit' | translate}}</span></button>
                    }
                  </div>

                </div>
                <div class="row small-text mt-5 mb-3">
                  <div class="col-4">
                    <div class="gray-text">{{'basic.email' | translate}}</div>
                    @if (editMode1 == false) {
                      <div>
                        <div class="bold-text">{{email}}</div>
                        @if (email == null) {
                          <div class="bold-text">{{'basic.noEmail' | translate}}</div>
                        }
                      </div>
                    }
                    @if (editMode1 == true) {
                      <div class="form-group">
                        <input type="email" id="emailId" class="form-control max-content" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" required>
                      </div>
                    }
                  </div>
                  <div class="col-4">
                    <div class="gray-text">{{'basic.interfaceLanguage' | translate}}</div>
                    @if (editMode1 === false) {
                      <div class="bold-text">
                        <div>{{callServiceLanguage.displayName}}</div>
                        @if (!callServiceLanguage.displayName) {
                          <div>{{'basic.noLanguage' | translate}}</div>
                        }
                      </div>
                    }
                    <div [hidden]="!editMode1">
                      <select class="form-select" (change)="languageChange($event.target.value)">
                        @if (!callServiceLanguage.displayName) {
                          <option disabled [selected]="!callServiceLanguage.displayName">{{'basic.noLanguage' | translate}}</option>
                        }
                        @for (language of interfaceLanguages; track $index) {
                          <option [selected]="callServiceLanguage.databaseLanguage === language.databaseLanguage" [value]="language.databaseLanguage">{{language.displayName}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                @if (editMode1) {
                  <div class="row">
                    <div class="col-12 mb-2">
                      <button type="submit" class="btn btn-primary">{{'basic.save' | translate}}</button>
                      <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit(1)">{{'basic.cancel' | translate}}</button>
                    </div>
                  </div>
                }
                <div class="border-bottom-96 mt-5"></div>
              </div>
              <div class="col-7 small-text border-start border-gray">
                <div class="gray-text">
                  <span>{{'basic.projects' | translate}}</span>
                  @if (!editMode2) {
                    <button class="btn btn-secondary float-end" type="button" (click)="toggleEdit(2)"><img src="assets/icons/edit_gray_24dp.svg" class="image-edit"><span class="ms-1">{{'basic.edit' | translate}}</span></button>
                  }
                </div>
                @if (projects.length === 0) {
                  <div>{{'planner.callServiceDetail.noProjects' | translate}}</div>
                }
                @if (projects.length != 0) {
                  <div>
                    @for (project of projects; track $index; let i = $index) {
                      <div class="bold-text">
                        {{project.id}}: {{project.name}}
                      </div>
                    }
                  </div>
                }
                @if (editMode2 == true) {
                  <div class="margin-top-1">
                    <div class=" gray-text">{{'planner.callServiceDetail.selectProjects' | translate}}</div>
                    <div class="mt-3 form-group row">
                      <div class="col-6">
                        <p class="gray-text">{{'basic.projects' | translate}}</p>
                        <select class="form-select" (change)="selectProject($event.target.value)">
                          <option [value]="">{{'planners.selectProjects' | translate}}</option>
                          @for (project of unselectedProjects; track $index) {
                            <option [value]="project.id">{{project.name}} {{project.id == currentProjectId ? ('planners.currentProject' | translate) : '' }}</option>
                          }
                        </select>
                        <div class="same-line mt-3">
                          @for (project of selectedProjects; track $index) {
                            <div  (click)="unselectProject(project.id)" style="cursor: pointer;" class="gap-between-elements text-align-center gray-text rounded-pill px-2">{{project.name}}</div>
                          }
                        </div>
                      </div>
                      <div>
                        <button type="button" id="saveButton" (click)="saveEdit(2)" class="btn btn-primary col-3">{{'basic.save' | translate}}</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit(2)">{{'basic.cancel' | translate}}</button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-5 mt-4">
              <div>
                <div class="margin-left-fix">
                  <img [src]="personAccount" class="image-position"><span class="ms-2 fs-6">{{'basic.account' | translate}}</span>

                  @if (!editMode3 && !createUser && !accountDisabled) {
                    <button class="btn btn-secondary float-end me-3 font-size-small" (click)="toggleEdit(3)"><img src="assets/icons/edit_gray_24dp.svg" class="image-edit"><span class="ms-1">{{'basic.edit' | translate}}</span></button>
                  }
                  @if (!createUser && !accountDisabled) {
                    <button class="float-end btn btn-secondary font-size-small me-1" (click)="disableAccount()">
                      <img class="disable-icon" src="assets/icons/person_off_gray_48.svg">
                      <span class="ms-1">{{'basic.disableAccount' | translate}}</span>
                    </button>
                  }
                  @if (!createUserActive && accountDisabled) {
                    <button class="float-end btn btn-primary font-size-small me-1" (click)="activateAccount()">
                      <img class="disable-icon" src="assets/icons/person_white_24dp.svg">
                      <span class="ms-1">{{'basic.activateAccount' | translate}}</span>
                    </button>
                  }
                  @if (accountDisabled && !createUserActive) {
                    <div class="gray-text font-size-small">({{'basic.disabled' | translate}})</div>
                  }
                </div>

              </div>
              @if (createUser) {
                <div>
                  <div class="gray-text mt-3 small-text">{{'planner.callServiceDetail.noAccount' | translate}}</div>
                  <button class="btn btn-primary mt-3" (click)="createAccount()"><span class=" position-plus">+</span><span class="small-text ms-1">{{'basic.createAccount' | translate}}</span></button>
                </div>
              }
              @if (!createUser) {
                <div>
                  @if (showUsername) {
                    <div class="gray-text small-text mt-3 ">
                      <span>{{'basic.username' | translate}}: </span>
                      <span class="black-text bold-text">{{username}}</span>
                      @if (editMode3) {
                        <button class="btn btn-sm btn-secondary ms-1" (click)="changeUsernameToggle()">{{'basic.change' | translate}}</button>
                      }
                    </div>
                  }
                  <form ngNativeValidate (ngSubmit)="saveEdit(3)">
                    @if (!showUsername && editMode3) {
                      <div>
                        <div class="bold-text mt-2">
                          @if (!createUserActive) {
                            <span>{{'basic.changeUsername' | translate}}</span>
                          }
                          @if (createUserActive) {
                            <span>{{'basic.createAccount' | translate}}</span>
                          }
                        </div>
                        @if (!createUserActive) {
                          <div>
                            <div class="small-text gray-text mt-2">{{'basic.oldUsername' | translate}}</div>
                            <div class="black-text bold-text small-text">{{username}}</div>
                          </div>
                        }
                        <div class="small-text gray-text mt-2">{{'basic.newUsername' | translate}}</div>
                        <input type="text" class="form-control max-content" [required]="!showUsername" [(ngModel)]="newUsername" [ngModelOptions]="{standalone: true}">
                      </div>
                    }
                    @if (showPassword) {
                      <div class="gray-text small-text mt-2">
                        <span>Password: </span>
                        <span class="black-text bold-text ms-2">********</span>
                        @if (editMode3) {
                          <button class="btn btn-sm btn-secondary ms-1" (click)="changePasswordToggle()">Change</button>
                        }</div>
                      }
                      @if (!showPassword && editMode3) {
                        <div>
                          <div class="small-text gray-text mt-2">
                            <span>{{'basic.password' | translate}}</span>
                            <a class="ms-2 small-text generate-link" (click)="generatePassword()">{{'basic.generatePassword' | translate}}</a>
                          </div>
                          <div class="password d-flex">
                            <input id="login-password" type="password" class="form-control password-length max-content" [required]="!showPassword" [(ngModel)]="newPassword" [ngModelOptions]="{standalone: true}">
                            <button (click)="hideShowPassword()" class="border border-gray" type="button">@if (!showGeneratedPassword) {
                              <img src="assets/icons/visibility_gray_24dp.svg">
                              } @if (showGeneratedPassword) {
                              <img src="assets/icons/visibility_off_gray_24dp.svg">
                            }</button>
                          </div>
                        </div>
                      }
                      @if (editMode3 == true) {
                        <div class="mb-2 mt-3">
                          <button type="submit" class="btn btn-primary">{{'basic.save' | translate}}</button>
                          <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit(3)">{{'basic.cancel' | translate}}</button>
                        </div>
                      }
                    </form>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
